import { branchSaveAllActions } from "./BranchSaveAllActions";

const initialState = {
  saveAllLoading: false,
  saveAllData: "",
  saveAllError: "",
};

const BranchSaveAllReducer = (state = initialState, action) => {
  switch (action.type) {
    case branchSaveAllActions.BRANCH_SAVEALL_LOADING:
      return {
        ...state,
        saveAllLoading: true,
      };
    case branchSaveAllActions.BRANCH_SAVEALL_SUCCESS:
      return {
        ...state,
        saveAllData: action.payload,
      };
    case branchSaveAllActions.BRANCH_SAVEALL_ERROR:
      return {
        ...state,
        saveAllError: action.payload,
      };
    default:
      return state;
  }
};

export default BranchSaveAllReducer;
